/**
 * Performs a SAML POST to the target URL in a new browser tab.
 * Creates a hidden form with the SAML response and submits it.
 * @param samlResponse - The base64-encoded SAML response
 * @param url - The target URL (IdP/SP assertion consumer service)
 * @param fieldName - The form field name (default: 'SAMLResponse' per SAML HTTP POST binding spec)
 * @param relayState - Optional RelayState value
 * @param target - Form target window (default: '_blank')
 */
export function samlPost(
  samlResponse: string,
  url: string,
  fieldName = 'SAMLFields',
  relayState?: string,
  target = '_blank',
) {
  // Create form element
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = url;
  form.target = target;
  form.style.display = 'none';

  // Add SAML response field
  const input = document.createElement('input');
  input.type = 'hidden';
  input.name = fieldName;
  input.value = samlResponse;
  form.appendChild(input);

  // Add RelayState if provided
  if (relayState) {
    const relayInput = document.createElement('input');
    relayInput.type = 'hidden';
    relayInput.name = 'RelayState';
    relayInput.value = relayState;
    form.appendChild(relayInput);
  }

  // Append to body (not a random div)
  document.body.appendChild(form);

  // Submit the form
  form.submit();

  // Remove form after a delay to ensure submission completes
  setTimeout(() => {
    if (form.parentNode) {
      form.parentNode.removeChild(form);
    }
  }, 1000);
}
